import { message } from "antd";
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from "../axios";

export const createCertificate = async (payload) => {
  try {
    const res = await axiosPost({
      path: "certificate",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const uploadCsv = async (payload) => {
  try {
    const res = await axiosPost({
      path: "certificate/upload",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const getCertificateByShareId = async (shareId) => {
  try {
    const res = await axiosGet({
      path: `certificate/share/${shareId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const updateCertificate = async (id, payload) => {
  try {
    const res = await axiosPatch({
      path: `certificate/${id}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const submitCertificate = async (id, payload) => {
  try {
    const res = await axiosPatch({
      path: `certificate/submit/${id}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const unSubmitCertificate = async (id, payload) => {
  try {
    const res = await axiosPatch({
      path: `certificate/unsubmit/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const editUserCertificate = async (id, payload) => {
  try {
    const res = await axiosPatch({
      path: `certificate/certificate-holder/${id}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const freezeCertificate = async (id) => {
  try {
    const res = await axiosPatch({
      path: `certificate/freeze/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const unFreezeCertificate = async (id) => {
  try {
    const res = await axiosPatch({
      path: `certificate/unfreeze/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const getCertificate = async (
  id,
  pageNumber = "",
  pageSize = "",
  search = ""
) => {
  try {
    const res = await axiosGet({
      path: `certificate?companyId=${id}&pageNumber=${pageNumber}&itemPerPage=${pageSize}&search=${search}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const getCertificateById = async (id) => {
  try {
    const res = await axiosGet({
      path: `certificate/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const getCertificateByCompany = async (id) => {
  try {
    const res = await axiosGet({
      path: `certificate/company-id/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const deleteCertificate = async (id) => {
  try {
    const res = await axiosDelete({
      path: `certificate/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const notificationCertificate = async (payload) => {
  try {
    const res = await axiosPost({
      path: "certificate/share-notification",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const shareByEmail = async (payload) => {
  try {
    const res = await axiosPost({
      path: "certificate/share-by-email",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
